"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _core = require("@material-ui/core");

var _RadioButton = _interopRequireDefault(require("./RadioButton.css"));

// Once again if function without fixed identity can potentially be passed here
// There is no benefit in doing this PureComponent
var RadioButton =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(RadioButton, _React$PureComponent);

  function RadioButton() {
    (0, _classCallCheck2.default)(this, RadioButton);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RadioButton).apply(this, arguments));
  }

  (0, _createClass2.default)(RadioButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          onChange = _this$props.onChange,
          options = _this$props.options,
          orientation = _this$props.orientation,
          selectedValue = _this$props.selectedValue;
      return React.createElement(_core.RadioGroup, {
        className: "".concat(classes.root, " ").concat(orientation),
        onChange: onChange,
        value: selectedValue
      }, options.map(function (option) {
        return React.createElement(_core.FormControlLabel, {
          label: option.label,
          disabled: option.disabled,
          control: React.createElement(_core.Radio, null),
          value: option.value,
          key: option.value
        });
      }));
    }
  }]);
  return RadioButton;
}(React.PureComponent);

RadioButton.defaultProps = {
  selectedValue: null,
  orientation: 'horizontal'
};
RadioButton.propTypes = {
  /**
   * Items passed into the component to be rendered as radio options.
   */
  options: PropTypes.arrayOf(PropTypes.shape({
    /**
     * The text to be used in an enclosing label element.
     */
    label: PropTypes.node.isRequired,

    /**
     * If `true`, the switch will be disabled.
     */
    disabled: PropTypes.bool,

    /**
     * Value of the selected radio button.
     */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  })),

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value`.
   * @param {string} value The `value` of the selected radio button
   */
  onChange: PropTypes.func.isRequired,

  /**
   * Value of the selected radio button.
   */
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),

  /**
   * Radio buttons orientation
   */
  orientation: PropTypes.oneOf(['vertical', 'horizontal'])
};

var _default = (0, _core.withStyles)(_RadioButton.default)(RadioButton);

exports.default = _default;